<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-create-copy`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 9h24V5H7a2 2 0 00-2 2v26h4V9zm36 6a2 2 0 00-2-2H15a2 2 0 00-2 2v28a2 2 0 002 2h28a2 2 0 002-2V15zM17 41V17h24v24H17zm16.414-19.071h-10a1 1 0 00-1 1v10a1 1 0 001 1h2a1 1 0 001-1v-4.154l7.305 7.305a1 1 0 001.414 0l1.414-1.414a1 1 0 000-1.414l-7.323-7.324h4.19a1 1 0 001-1v-2a1 1 0 00-1-1z"/></svg>
</template>
<script>

export default {
  name: 'IconCreateCopy',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
